import React from 'react';
import { CnLayoutCell as UICnLayoutCell } from '@cainiaofe/cn-ui';
const CnLayoutCell = (props) => {
    const { children } = props || {};
    return <UICnLayoutCell>{children}</UICnLayoutCell>;
};
CnLayoutCell.displayName = 'CnLayoutCell';
export default CnLayoutCell;
export { CnLayoutCell };
